import { render, staticRenderFns } from "./JDEFlow.vue?vue&type=template&id=56a885ea&scoped=true&"
import script from "./JDEFlow.vue?vue&type=script&lang=js&"
export * from "./JDEFlow.vue?vue&type=script&lang=js&"
import style0 from "./JDEFlow.vue?vue&type=style&index=0&id=56a885ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a885ea",
  null
  
)

export default component.exports